export default "__VITE_ASSET__BiKLQm61__"